import { getMachineImagePath } from './machineImageUtils';

// Test model names that should have images
const TEST_MODELS = [
  'M350', 'M353', 'M550', 'M552', 'M553', 'M701', 'M703', 'M725', 'Hi5Packer',
  'M052', 'M200-HS', 'M203-S-Bobin', 'M203-S-Magazin', 'M242', 'M252-0,5', 'M252', 'M507-OCS',
  'M459'
];

// Development utility to validate machine images
export const validateMachineImages = async () => {
  console.log('🔍 Validating machine images...');
  
  const results = {
    found: [] as string[],
    missing: [] as string[],
    total: 0
  };

  for (const modelName of TEST_MODELS) {
    results.total++;
    
    try {
      const imagePath = await getMachineImagePath(modelName);
      if (imagePath && !imagePath.includes('FOCKE.png')) {
        results.found.push(modelName);
        console.log(`✅ ${modelName} - Image found`);
      } else {
        results.missing.push(modelName);
        console.warn(`❌ ${modelName} - Image missing`);
      }
    } catch (error) {
      results.missing.push(modelName);
      console.error(`❌ ${modelName} - Error loading image:`, error);
    }
  }

  console.log(`\n📊 Image Validation Summary:`);
  console.log(`✅ Found: ${results.found.length}/${results.total}`);
  console.log(`❌ Missing: ${results.missing.length}/${results.total}`);
  
  if (results.missing.length > 0) {
    console.log(`\n🚨 Missing Images:`);
    results.missing.forEach(machine => console.log(`   • ${machine}`));
  }

  return results;
};

// Helper to check if a specific machine has an image
export const checkMachineImage = async (machineType: string): Promise<boolean> => {
  try {
    const imagePath = await getMachineImagePath(machineType);
    return !!imagePath && !imagePath.includes('FOCKE.png');
  } catch {
    return false;
  }
};
